import produce from 'immer';
import {
  BreakRuleWithUsageListItemResponse,
  DutyModelWithAdoptingDepartmentsListItemResponse,
  RoundingRuleWithUsageListItemResponse,
} from '../../../api';
import { baseLocationWorkingTimeActions } from '../actions';

/** Duty models, break rules and rounding rules of one location, as managed in the location modal. */
export interface LocationWorkingTimeState {
  dutyModels: {
    data: DutyModelWithAdoptingDepartmentsListItemResponse[];
    ok: boolean | undefined;
  };
  dutyModelCrud: {
    ok: boolean | undefined;
    errors: Record<string, string[]> | undefined;
  };
  breakRules: {
    data: BreakRuleWithUsageListItemResponse[];
    ok: boolean | undefined;
  };
  breakRuleCrud: {
    ok: boolean | undefined;
  };
  roundingRules: {
    data: RoundingRuleWithUsageListItemResponse[];
    ok: boolean | undefined;
  };
  roundingRuleCrud: {
    ok: boolean | undefined;
  };
}

export const INITIAL_LOCATION_WORKING_TIME_STATE: LocationWorkingTimeState = {
  dutyModels: {
    data: [],
    ok: undefined,
  },
  dutyModelCrud: {
    ok: undefined,
    errors: undefined,
  },
  breakRules: {
    data: [],
    ok: undefined,
  },
  breakRuleCrud: {
    ok: undefined,
  },
  roundingRules: {
    data: [],
    ok: undefined,
  },
  roundingRuleCrud: {
    ok: undefined,
  },
};

export function BaseLocationWorkingTimeReducer(
  state: LocationWorkingTimeState = INITIAL_LOCATION_WORKING_TIME_STATE,
  action: any
): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Duty models
      case baseLocationWorkingTimeActions.loadDutyModels.type:
        draftState.dutyModels.ok = undefined;
        return;

      case baseLocationWorkingTimeActions.setDutyModels.type:
        draftState.dutyModels.data = action.payload;
        return;

      case baseLocationWorkingTimeActions.successDutyModels.type:
        draftState.dutyModels.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorDutyModels.type:
        draftState.dutyModels.ok = false;
        return;

      case baseLocationWorkingTimeActions.resetDutyModels.type:
        draftState.dutyModels = INITIAL_LOCATION_WORKING_TIME_STATE.dutyModels;
        draftState.dutyModelCrud = INITIAL_LOCATION_WORKING_TIME_STATE.dutyModelCrud;
        return;

      // Duty model create / update / delete / activation
      case baseLocationWorkingTimeActions.createDutyModel.type:
      case baseLocationWorkingTimeActions.updateDutyModel.type:
      case baseLocationWorkingTimeActions.deleteDutyModel.type:
      case baseLocationWorkingTimeActions.setDutyModelActivation.type:
        draftState.dutyModelCrud.ok = undefined;
        draftState.dutyModelCrud.errors = undefined;
        return;

      case baseLocationWorkingTimeActions.successDutyModelCrud.type:
        draftState.dutyModelCrud.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorDutyModelCrud.type:
        draftState.dutyModelCrud.ok = false;
        draftState.dutyModelCrud.errors = action.errors;
        return;

      // Break rules
      case baseLocationWorkingTimeActions.loadBreakRules.type:
        draftState.breakRules.ok = undefined;
        return;

      case baseLocationWorkingTimeActions.setBreakRules.type:
        draftState.breakRules.data = action.payload;
        return;

      case baseLocationWorkingTimeActions.successBreakRules.type:
        draftState.breakRules.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorBreakRules.type:
        draftState.breakRules.ok = false;
        return;

      case baseLocationWorkingTimeActions.resetBreakRules.type:
        draftState.breakRules = INITIAL_LOCATION_WORKING_TIME_STATE.breakRules;
        draftState.breakRuleCrud = INITIAL_LOCATION_WORKING_TIME_STATE.breakRuleCrud;
        return;

      // Break rule create / update / delete
      case baseLocationWorkingTimeActions.createBreakRule.type:
      case baseLocationWorkingTimeActions.updateBreakRule.type:
      case baseLocationWorkingTimeActions.deleteBreakRule.type:
      case baseLocationWorkingTimeActions.setBreakRuleActivation.type:
        draftState.breakRuleCrud.ok = undefined;
        return;

      case baseLocationWorkingTimeActions.successBreakRuleCrud.type:
        draftState.breakRuleCrud.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorBreakRuleCrud.type:
        draftState.breakRuleCrud.ok = false;
        return;

      // Rounding rules
      case baseLocationWorkingTimeActions.loadRoundingRules.type:
        draftState.roundingRules.ok = undefined;
        return;

      case baseLocationWorkingTimeActions.setRoundingRules.type:
        draftState.roundingRules.data = action.payload;
        return;

      case baseLocationWorkingTimeActions.successRoundingRules.type:
        draftState.roundingRules.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorRoundingRules.type:
        draftState.roundingRules.ok = false;
        return;

      case baseLocationWorkingTimeActions.resetRoundingRules.type:
        draftState.roundingRules = INITIAL_LOCATION_WORKING_TIME_STATE.roundingRules;
        draftState.roundingRuleCrud = INITIAL_LOCATION_WORKING_TIME_STATE.roundingRuleCrud;
        return;

      // Rounding rule create / update / delete
      case baseLocationWorkingTimeActions.createRoundingRule.type:
      case baseLocationWorkingTimeActions.updateRoundingRule.type:
      case baseLocationWorkingTimeActions.deleteRoundingRule.type:
      case baseLocationWorkingTimeActions.setRoundingRuleActivation.type:
        draftState.roundingRuleCrud.ok = undefined;
        return;

      case baseLocationWorkingTimeActions.successRoundingRuleCrud.type:
        draftState.roundingRuleCrud.ok = true;
        return;

      case baseLocationWorkingTimeActions.errorRoundingRuleCrud.type:
        draftState.roundingRuleCrud.ok = false;
        return;
    }
  });
}
